import { trackEvent } from "@/lib/analytics";

export type TemplateDownloadFormat = "docx" | "pdf";

/**
 * Save a generated template file and record the download. Before this existed
 * the gallery fired no event at all, so Umami could see 183 organic sessions
 * a month clicking through to /id/template-cv-ats and nothing about whether
 * any of them took a template home.
 */
export function saveTemplateFile(
  filename: string,
  blob: Blob,
  params: { template: string; format: TemplateDownloadFormat },
) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);

  trackEvent("template_download", params);
}
